import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    triggers: [],
    settings: {},
    drivers: [],
    templates: [],
    form: {
      name: '',
      driver_id: '',
      event_end: '',
      event_start: '',
      push_notification_channel: 0,
      email_channel: 0,
      web_page_channel: 0,
      web_pages: [],
      // message_template_id: '',
      max_product_to_send: 5,
      active: 1,
      product_ids: [],
    },
  },
  actions,
  mutations,
  getters,
};
